import { render, staticRenderFns } from "./GenreList.vue?vue&type=template&id=19049d7f"
import script from "./GenreList.vue?vue&type=script&lang=js"
export * from "./GenreList.vue?vue&type=script&lang=js"
import style0 from "./GenreList.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports